<template>
  <CommonModal>
    <div class="flex flex-col h-full">
      <div class="flex-grow modal-scroll">
        <table class="my-2 text-xs w-full shadow">
          <tbody>
            <tr>
              <th class="bg-corepla-bg-dark text-white text-xs p-2 font-normal text-left">
                {{ $t("selection_site.selection_site") }}
              </th>
              <th class="bg-corepla-bg-dark text-white text-xs p-2 font-normal">
                {{ $t("common.quantity") }}
              </th>
            </tr>
            <tr
              v-for="warehouse in lot.warehouses"
              :key="'warehouse-modal-' + lot.uuid + '-' + warehouse.uuid"
            >
              <td class="p-2 text-xs">
                <div class="font-bold">
                  {{ warehouse.displayName }}
                </div>
                <div>{{ warehouse.address }}</div>
              </td>
              <td class="p-2 text-xs text-center">
                {{ warehouse.quantity }} t
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <a
          href="#"
          class="btn btn-cancel"
          @click.prevent="$emit('close')"
        >{{ $t("common.close") }}</a>
      </div>
    </div>
  </CommonModal>
</template>

<script setup>
import CommonModal from '@/components/CommonModal.vue';

const emit = defineEmits(['close'])
const props = defineProps({
    lot: {
        type: Object,
        required: true
    }
})

</script>